import type { Category } from '@/types';

export const categories: Category[] = [
  {
    slug: 'technology',
    name: 'Technology',
    description: 'The latest in tech, AI, and digital innovation',
    icon: 'ri-computer-line',
    count: 24,
  },
  {
    slug: 'business',
    name: 'Business',
    description: 'Startups, markets, and entrepreneurial insights',
    icon: 'ri-briefcase-line',
    count: 18,
  },
  {
    slug: 'design',
    name: 'Design',
    description: 'UI/UX, graphic design, and creative processes',
    icon: 'ri-palette-line',
    count: 15,
  },
  {
    slug: 'culture',
    name: 'Culture',
    description: 'Arts, lifestyle, and social trends',
    icon: 'ri-landscape-line',
    count: 21,
  },
  {
    slug: 'science',
    name: 'Science',
    description: 'Discoveries, research, and the natural world',
    icon: 'ri-flask-line',
    count: 12,
  },
  {
    slug: 'opinion',
    name: 'Opinion',
    description: 'Perspectives, essays, and thought pieces',
    icon: 'ri-quill-pen-line',
    count: 9,
  },
];